import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Table } from 'semantic-ui-react';
import _ from 'lodash';
import { connect } from 'react-redux';
// local
// views
import ConfirmTableRow from './ConfirmTableRow';
import TableHeaderCellSort from 'app/ui/commons/TableHeaderCellSort';
// actions
import { sort } from 'app/redux/actions/confirmDelivery/data';

class ConfirmTable extends Component {
    onClickSort = newColumn => {
        let { column, direction } = this.props.row.sort;
        if (newColumn !== column) {
            column = newColumn;
            direction = 'ascending';
        } else {
            direction = direction === 'ascending' ? 'descending' : 'ascending';
        }
        this.props.dispatch(sort(this.props.row.date, column, direction));
    };

    render() {
        const { date, sort, entries } = this.props.row;
        return (
            <Table sortable>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell width="2">ATM</Table.HeaderCell>
                        <TableHeaderCellSort title="PACIENTE" column="patient.name" sort={sort} onClick={() => this.onClickSort('patient.name')} width="4" />
                        <TableHeaderCellSort
                            title="FORNECEDOR"
                            column="supplier.name"
                            sort={sort}
                            onClick={() => this.onClickSort('supplier.name')}
                            width="4"
                        />
                        <Table.HeaderCell textAlign="center" width="2">
                            CILINDROS SOLICITADOS
                        </Table.HeaderCell>
                        <Table.HeaderCell textAlign="center" colSpan="2" width="3">
                            ENTREGAS
                        </Table.HeaderCell>
                        <Table.HeaderCell width="1" style={{ minWidth: 120 }} />
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {_.map(entries, entry => {
                        const rowKey = `patient-${entry.id}`;
                        return <ConfirmTableRow key={rowKey} date={date} row={entry} />;
                    })}
                </Table.Body>
            </Table>
        );
    }
}

ConfirmTable.propTypes = {
    dispatch: PropTypes.func,
    row: PropTypes.object,
};

export default connect()(ConfirmTable);
